import { render, staticRenderFns } from "./estadisticas.vue?vue&type=template&id=08eac293&"
import script from "./estadisticas.vue?vue&type=script&lang=js&"
export * from "./estadisticas.vue?vue&type=script&lang=js&"
import style0 from "./estadisticas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports